import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import ImplantSection from '../components/ImplantSection';
import { useLanguage } from '../contexts/LanguageContext';
import { localizedPath } from '../seo/routes';
import CtaSection from '../components/CtaSection';

const ImplantsPage: React.FC = () => {
  const { translations, language } = useLanguage();

  // Cross-Link Notfall-Cluster (Plan §7.4): Implantat-Probleme, auch Fremdimplantate.
  // Defensiv geguarded — fehlt implants.foreignImplants, entfällt die Sektion.
  const foreign = translations.implants?.foreignImplants;

  return (
    <main className="pt-20 lg:pt-32">
      <Seo pageKey="implants" />
      <div className="bg-navy text-white py-20">
        <div className="container-custom">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">{translations.implants.title}</h1>
          <p className="text-xl">{translations.implants.intro.split('.')[0]}.</p>
        </div>
      </div>
      <ImplantSection />
      {foreign?.title && (
        <section className="py-16 md:py-20 bg-gray-50">
          <div className="container-custom">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-3xl md:text-4xl font-bold text-navy mb-6">{foreign.title}</h2>
              {foreign.intro && (
                <p className="text-lg text-gray-700 mb-4 leading-relaxed">{foreign.intro}</p>
              )}
              <p className="text-lg text-gray-700 mb-8 leading-relaxed">{foreign.body}</p>
              {foreign.linkText && (
                <Link
                  to={localizedPath('emergency-tourists', language)}
                  className="inline-flex items-center text-mint-dark font-bold hover:text-navy transition-colors underline"
                >
                  {foreign.linkText}
                </Link>
              )}
            </div>
          </div>
        </section>
      )}
      <CtaSection />
    </main>
  );
};

export default ImplantsPage; 